import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store';

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')
const DefaultContainerPublic = () => import('@/containers/DefaultContainerPublic')

// Views
const Dashboard = () => import('@/views/Dashboard')
const Vehicles = () => import('@/views/Vehicles')
const Routes = () => import('@/views/Routes')
const RouteDetails = () => import('@/views/RouteDetails')
const Requests = () => import('@/views/Requests')
const Profile = () => import('@/views/Profile')
const ChangePwd = () => import('@/views/ChangePwd')
const Login = () => import('@/views/Login')
//const ResetPassword = () => import('@/views/ResetPassword')
const ChangeForgotPwd = () => import('@/views/ChangeForgotPwd')

Vue.use(Router)

const router = new Router({
  mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [{
    path: '/',
    redirect: '/vehicles',
    name: 'Home',
    component: DefaultContainer,
    meta: { requireAuth: true },
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: Dashboard
    }, {
      path: 'vehicles',
      name: 'Veicoli',
      component: Vehicles
    }, {
      path: 'routes',
      name: 'Percorsi',
      component: Routes
    }, {
      path: 'routes/:id',
      name: 'Dettagli Percorso',
      component: RouteDetails
    }, {
      path: 'requests',
      name: 'Richieste',
      component: Requests
    }, {
      path: 'profile',
      name: 'Profilo',
      component: Profile
    }, {
      path: 'changepwd',
      name: 'Cambio password',
      component: ChangePwd,
    }]
  }, {
        path: '/',
        redirect: '/resetPassword',
        name: 'Info',
        component: DefaultContainerPublic,
        children: [
            {
              path: 'changeForgotPassword',
              name: 'Change Password',
              component: ChangeForgotPwd
            }
        ]
    }, {
    path: '/',
    // redirect: '/pages/404',
    name: 'Pages',
    component: {
      render (c) { return c('router-view') }
    },
    children: [{
      path: 'login',
      name: 'Login',
      component: Login
    }]
  }]
});

router.beforeEach((to, from, next) => {
  if(store.state.subuser.passwordExpired && to.path != "/login"
                                         && to.path != "/changepwd"){
    next('/changepwd');
  } else if (to.matched.some(record => record.meta.requireAuth)) {
    if (store.getters.isLogged) {
      next();
      return;
    }
    next('/login');
  } else {
    next();
  }
});

export default router;
